import { Box } from "@gemini/core";
import { StateMessage } from "@gemini/ui";
import { memo } from "react";
import type { FunctionComponent, PropsWithChildren } from "react";

type TabPanelLikeProps = PropsWithChildren<{
  isActive?: boolean | undefined;
}>;

type CreateTabPanelInput = {
  label: string;
  description: string;
  Component: FunctionComponent<TabPanelLikeProps>;
};

export const createTabPanel = ({
  label,
  description,
  Component,
}: CreateTabPanelInput) => {
  return {
    id: label,
    label,
    Component: memo(({ children, ...componentProps }: TabPanelLikeProps) => {
      return (
        <Box
          as="section"
          display="flex"
          flexDirection="column"
          paddingHorizontal="spacing.12"
          paddingVertical="spacing.20"
          height={400}
        >
          <StateMessage
            variant="info"
            marginBottom="spacing.20"
          >
            {description}:
          </StateMessage>
          <Component {...componentProps}>{children}</Component>
        </Box>
      );
    }),
  };
};
